import React, { FC } from 'react';

import { ButtonProps } from '@lglp/components';
import { Cta } from '@lglp/prismic-client';

import CommonButton from '../CommonButton/CommonButton';
import { Arrow } from '../Icons';
import { LinkedComponent } from '../LinkedComponent';
import styles from './CTAButton.module.scss';

export const CTAButton: FC<CTAButtonProps> = ({
  cta,
  revert = false,
  className,
  ...rest
}) => {
  return (
    <LinkedComponent link={cta.link}>
      <CommonButton
        {...(cta.link ? { as: 'div' } : undefined)}
        className={[
          styles.cta,
          'animate-svg',
          revert && styles.reverted,
          className,
        ]}
        label={cta.label}
        svg={Arrow}
        {...rest}
      />
    </LinkedComponent>
  );
};

type CTAButtonProps = ButtonProps & {
  cta: Cta;
  revert?: boolean;
};
